/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Check } from 'lucide-react';

export const Checkbox = ({
  isDisable = false,
  field = {},
  setValue = () => {},
}) => {
  return (
    <div
      className={`tw-flex tw-gap-3 tw-items-center ${
        isDisable ? 'tw-cursor-default' : 'tw-cursor-pointer'
      }`}
      onClick={() => {
        if (isDisable) return;
        setValue(field?.value === 'true' ? 'false' : 'true');
      }}
    >
      <span
        className={`tw-w-7 tw-h-7 tw-border-solid tw-border-2 tw-border-green-700 ${
          field?.value == 'true' ? 'tw-bg-green-700' : ''
        } tw-rounded-lg tw-p-[0.01rem] ${
          isDisable ? 'tw-cursor-default' : 'tw-cursor-pointer'
        } tw-flex tw-justify-center tw-items-center`}
      >
        {field?.value === 'true' ? (
          <Check size={16} className='tw-text-white' strokeWidth={3} />
        ) : null}
      </span>
      <span
        className={`tw-font-regular tw-text-zinc-700 tw-capitalize tw-leading-none ${
          isDisable ? 'tw-text-[#9ca3af]' : ''
        }`}
      >
        {field.title}
      </span>
    </div>
  );
};
